/**
 * Subscriptions' user/vehicle to badge association
 */
type SubPlanAssociationItemType =
    'USER' |
    'VEHICLE' |
    'EXPORT';
const SubPlanAssociationItemType = (() => {
    const USER: SubPlanAssociationItemType = 'USER';
    const VEHICLE: SubPlanAssociationItemType = 'VEHICLE';
    const EXPORT: SubPlanAssociationItemType = 'EXPORT';
    function values(): SubPlanAssociationItemType[] {
        return [
            USER,
            VEHICLE,
            EXPORT
        ];
    }
    return { USER, VEHICLE, EXPORT, values };
})();

export { SubPlanAssociationItemType };
